import '../scss/layout.scss';
import Marquee from 'react-fast-marquee';

import Aerofarms from '../assets/partners/aerofarms.png'
import ATM from '../assets/partners/atm.png'
import Cooper from '../assets/partners/cooper.png'
import Dyopath from '../assets/partners/dyopath.png'
import Entrust from '../assets/partners/entrust.png'
import GH from '../assets/partners/gh-port-bureau.png'
import Inevitable from '../assets/partners/inevitable.png'
import Nissan from '../assets/partners/nissan.png'
import Odfjell from '../assets/partners/odfjell.png'
import RaceRock from '../assets/partners/race-rock.png'
import RadialFlow from '../assets/partners/radial-flow.png'
import Soliton from '../assets/partners/soliton.png'
import STHG from '../assets/partners/sthg.png'

export const Partners = () => {
    // First marquee items
    const marquee1Items = [
        { src: Entrust, alt: "Entrust" },
        { src: Odfjell, alt: "Odfjell" },
        { src: RadialFlow, alt: "Radial Flow" },
        { src: Nissan, alt: "Nissan" },
        { src: Aerofarms, alt: "Aerofarms" },
        { src: GH, alt: "Greater Houston Port Bureau" }
    ];

    // Second marquee items
    const marquee2Items = [
        { src: Inevitable, alt: "Inevitable" },
        { src: Soliton, alt: "Soliton" },
        { src: STHG, alt: "S/T Health Group" },
        { src: ATM, alt: "Texas A&M University" },
        { src: Dyopath, alt: "Dyopath" },
        { src: Cooper, alt: "Cooper" },
        { src: RaceRock, alt: "Race Rock" }
    ];

    return(
        <div className='partners'>
            {/* <div className='still'>
                <div className='group'>
                    <div className='marquee-itm'>
                        <img src={Entrust} alt="Entrust" className='img'/>
                    </div>
                    <div className='marquee-itm'>
                        <img src={Odfjell} alt="Odfjell" className='img'/>
                    </div>
                    <div className='marquee-itm'>
                        <img src={RadialFlow} alt="Radial Flow" className='img'/>
                    </div>
                </div>
                <div className='group'>
                    <div className='marquee-itm'>
                        <img src={Nissan} alt="Nissan" className='img'/>
                    </div>
                    <div className='marquee-itm'>
                        <img src={Aerofarms} alt="Aerofarms" className='img'/>
                    </div>
                    <div className='marquee-itm'>
                        <img src={GH} alt="Greater Houston Port Bureau" className='img'/>
                    </div>
                </div>
            </div> */}
            {/* <div className='still'>
                <div className='group'>
                    <div className='marquee-itm'>
                        <img src={Inevitable} alt="Inevitable" className='img'/>
                    </div>
                    <div className='marquee-itm'>
                        <img src={Soliton} alt="Soliton" className='img'/>
                    </div>
                    <div className='marquee-itm'>
                        <img src={STHG} alt="S/T Health Group" className='img'/>
                    </div>
                    <div className='marquee-itm'>
                        <img src={ATM} alt="Texas A&M University" className='img'/>
                    </div>
                </div>
                <div className='group'>
                    <div className='marquee-itm'>
                        <img src={Dyopath} alt="Dyopath" className='img'/>
                    </div>
                    <div className='marquee-itm'>
                        <img src={Cooper} alt="Cooper" className='img'/>
                    </div>
                    <div className='marquee-itm'>
                        <img src={RaceRock} alt="Race Rock" className='img'/>
                    </div>
                </div>
            </div> */}
            <Marquee speed={100} gradient={false} direction='right' loop={0}>
                {/* Duplicate items for seamless looping */}
                {[...marquee1Items, ...marquee1Items, ...marquee1Items].map((item, index) => (
                    <div key={`marquee1-${index}`} className='marquee-itm'>
                        <img src={item.src} alt={item.alt} className='img'/>
                    </div>
                ))}
            </Marquee>
            <Marquee speed={100} gradient={false} loop={0}>
                {/* Duplicate items for seamless looping */}
                {[...marquee2Items, ...marquee2Items, ...marquee2Items].map((item, index) => (
                    <div key={`marquee2-${index}`} className='marquee-itm'>
                        <img src={item.src} alt={item.alt} className='img'/>
                    </div>
                ))}
            </Marquee>
        </div>
    )
}